export type OacChannelLastUpdateRow = {
  channelId: string;
  channelDisplayName: string;
  lastPublishedAt: string | null;
  lastUploadAt: string | null;
  lastScheduledAtAny?: string | null;
  lastScheduledThisMonth?: string | null;
};

export type OacActivityStatus = "compliant" | "scheduled" | "noActivity";

export const OAC_ACTIVITY_STATUS_ORDER: Record<OacActivityStatus, number> = {
  noActivity: 0,
  scheduled: 1,
  compliant: 2,
};

export const OAC_ACTIVITY_STATUS_LABEL: Record<OacActivityStatus, string> = {
  compliant: "Compliant",
  scheduled: "Scheduled",
  noActivity: "No activity",
};

function isInCurrentMonth(iso: string | null | undefined): boolean {
  if (!iso) return false;
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return false;
    const now = new Date();
    return (
      d.getUTCFullYear() === now.getUTCFullYear() &&
      d.getUTCMonth() === now.getUTCMonth()
    );
  } catch {
    return false;
  }
}

/**
 * An upload or a publish this month counts as activity: a channel releasing a
 * backlog uploaded in earlier months is still compliant. Scheduled = nothing yet
 * this month, but a video is scheduled to go live later this month.
 */
export function getOacActivityStatus(
  row: Pick<
    OacChannelLastUpdateRow,
    "lastUploadAt" | "lastPublishedAt" | "lastScheduledThisMonth"
  >
): OacActivityStatus {
  const uploadedThisMonth = isInCurrentMonth(row.lastUploadAt);
  const publishedThisMonth = isInCurrentMonth(row.lastPublishedAt);
  const scheduledThisMonth = isInCurrentMonth(row.lastScheduledThisMonth);

  if (uploadedThisMonth || publishedThisMonth) return "compliant";
  if (scheduledThisMonth) return "scheduled";
  return "noActivity";
}

export function oacActivityTagSeverity(
  status: OacActivityStatus
): "success" | "warning" | "danger" | undefined {
  if (status === "compliant") return "success";
  if (status === "scheduled") return "warning";
  if (status === "noActivity") return "danger";
  return undefined;
}
